import getAppState from 'app-state';

// TODO: Get inline mode to work with a toolbar that does NOT float

/**
 * Note: We have another old TinyMCE config that is used for some things at:
 * module/rcm-core/core/public/rcm-html-editor/dist/adapter-tinymce/rcm-html-editor.js
 */
export const TINYMCE_OPTIONS = {
    branding: false,
    custom_elements: 'style',
    extended_valid_elements: 'style',
    menubar: false,
    plugins: 'code textcolor autoresize lists advlist',
    external_plugins: {
        'linkwithjqueryautocomplete': '/vendor/rcm-tinymce/plugins/linkwithjqueryautocomplete/plugin.min.js',
    },
    link_list: "/rcm-page-search/title?format=tinyMceLinkList", // Used by linkwithjqueryautocomplete plugin
    relative_urls: false,
    statusbar: false,
    textcolor_map:
        getAppState<string[]>('rcmHtmlEditorOptions.textcolor_map', []),
    toolbar: (
        'code | undo redo | cut copy paste | styleselect | ' +
        'forecolor bold italic underline ' +
        'strikethrough superscript subscript | ' +
        'alignleft aligncenter alignright alignjustify | ' +
        'bullist numlist outdent indent | ' +
        'link unlink anchor | ' +
        'removeformat'
    ),
};

export const SANITIZE_OPTIONS = {
    allowedAttributes: false, // Boolean `false` actually means 'Allow ALL attributes'
    allowedTags: [
        'b', 'i', 'em', 'strong', 'a', 'span', 'div', 'p',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'hr', 'br', 'img', 'sub', 'sup', 'style', 'li', 'ul', 'ol'
    ],
};
